Object.defineProperty(exports, "__esModule", {
  value: true,
});

// Customizable Area Start
exports.validationApiContentType = "application/json";
exports.validationApiMethodType = "GET";
exports.exampleAPiEndPoint = "EXAMPLE_URL";
exports.exampleAPiMethod = "POST";
exports.exampleApiContentType = "application/json";
exports.textInputPlaceHolder = "Enter Text";
exports.labelTitleText = "pushnotifications";
exports.labelBodyText = "pushnotifications Body";

exports.btnExampleTitle = "CLICK ME";

exports.getNotificationsEndPoint = "push_notifications/push_notifications";
exports.getNotificationsAPIMethod = "GET";
// Customizable Area End
